// frontend/src/hooks/useHeartbeat.ts
import { useEffect, useRef } from 'react';
import api from '../services/apiConfig';

const HEARTBEAT_INTERVAL_MS = 30_000; // 30 segundos

/**
 * Hook que envia um heartbeat ao servidor a cada 30 segundos
 * enquanto o usuário estiver com a aba aberta e autenticado.
 * Deve ser montado uma única vez no componente raiz autenticado.
 */
const useHeartbeat = (isAuthenticated: boolean) => {
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const sendHeartbeat = async () => {
        try {
            await api.post('/sessions/heartbeat');
        } catch (err) {
            // Silencioso — não deve interromper a UX
        }
    };

    useEffect(() => {
        if (!isAuthenticated) return;

        // Envia imediatamente ao montar
        sendHeartbeat();

        intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [isAuthenticated]);
};

export default useHeartbeat;
